import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

// ✅ Images
import bgImage from "../../images/bg/testimonial-bg.png";
import gifShape from "../../images/icon/animated-gif03.gif";
import avatar1 from "../../images/avatar/hemanth-spotmies.jpg";
import avatar2 from "../../images/avatar/img02.jpg";
import avatar3 from "../../images/avatar/img03.jpg";
import avatar4 from "../../images/avatar/img04.jpg";
import avatar5 from "../../images/avatar/user.png";

const testimonials = [
  {
    id: 1,
    source: "Spotmies",
    rating: "5.0",
    content:
      '“I am totally impressed with their expertise in blockchain. The quality of work and commitment to the deadline is very impressive. We are looking forward to collaborate for more projects in future.”',
    name: "Hemanth Kumar V",
    designation: "Co-Founder & COO - Spotmies",
    avatar: avatar1,
  },
  {
    id: 2,
    source: "Clutch",
    rating: "4.9",
    content:
      '“Good professional advice and assistance, Prompt customer service, Outcomes delivered on quoted timescale, and cost Competitive charges.”',
    name: "Mallikarjun Nagdhari",
    designation: "Sr. Manager at TCS",
    avatar: avatar5,
  },
  {
    id: 3,
    source: "",
    rating: "5.0",
    content:
      '“Their automation solutions saved us countless hours. Tasks that took days are now completed in minutes. The ROI was almost immediate.”',
    name: "Sai Rama Krishna B",
    designation: "Software Developer - OpenText",
    avatar: avatar5,
  },
  {
    id: 4,
    source: "GoodFirms",
    rating: "5.0",
    content:
      '“Their custom ERP transformed our operations. We’ve seen a massive boost in sales tracking efficiency and CRM organization.Thanks!”',
    name: "Sanket",
    designation: "MD at Everest Woven Industries",
    avatar: avatar5,
  },
  {
    id: 5,
    source: "Clutch",
    rating: "4.7",
    content:
      '“We gained deep insights into customer behavior and performance. Their analytics made our decision-making sharper and more confident.”',
    name: "Rambabu V",
    designation: "MD - Priyanka Agro Farms",
    avatar: avatar5,
  },
  {
    id: 6,
    source: "Clutch",
    rating: "5.0",
    content:
      '“Managing employees is now effortless. The CRM they built is so good, user-friendly, and highly efficient”',
    name: "Raju V",
    designation: "Manager - IBCC Srikakulam",
    avatar: avatar5,
  },
];

const TestimonialSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".testimonial.bg_img");
    if (bgEl) bgEl.style.backgroundImage = `url(${bgImage})`;
  }, []);

  return (
    <section className="testimonial pb-150 bg_img">
      <div className="container">
        <div className="sec-title sec-title-center tes-sec-title text-center mb-50">
          <span className="sub-title mb-15">Our Testimonial</span>
          <h2 className="title">
            Hear from our
            <img src={gifShape} alt="shape" /> happy customers
          </h2>
        </div>
      </div>

      <div className="xb-testimonial-slider">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          speed={5000}
          spaceBetween={30}
          allowTouchMove={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1700: { slidesPerView: 5 },
            1600: { slidesPerView: 4 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            576: { slidesPerView: 1 },
            0: { slidesPerView: 1 },
          }}
          className="testimonial-marquee"
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="xb-testimonial-item">
                <div className="xb-item--inner xb-border" style={{ minHeight: '280px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <p className="xb-item--content">{item.content}</p>
                  <div className="xb-item--author ul_li">
                    <div className="xb-item--avatar">
                      <img src={item.avatar} alt={item.name} />
                    </div>
                    <div className="xb-item--holder">
                      <h3 className="xb-item--name">{item.name}</h3>
                      <span className="xb-item--desig">{item.designation}</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
